import { LoadingOutlined } from '@ant-design/icons'
import PrintEmailContent from '@components/PrintEmailContent'
import { ApiService } from '@services/ApiService'
import router from '@stores/router'
import { getQueryParams } from '@utils/functions'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

const Template = () => {
  const { id, type } = getQueryParams(
    router.location.search,
    router.location.state
  )
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  useEffect(() => {
    document.title = getTabName(type)
    if (id) {
      setLoading(true)
      getTemplate(id, getFunctionGetTemplate(type))
    } else {
      setError(new Error('Missing parameter id'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getTabName = type => {
    switch (type) {
      case 'specialistAgreement':
        return 'Specialist Agreement'
      default:
        return 'kawaconn Template'
    }
  }

  const getFunctionGetTemplate = type => {
    switch (type) {
      case 'specialistAgreement':
        return ApiService.Specialist.ViewSpecialistAgreement
      default:
        return null
    }
  }

  const getTemplate = async (id, functionGetTemplate) => {
    try {
      const { data } = await functionGetTemplate(id)
      setData(data)
      setLoading(false)
      if (!data) {
        throw new Error('Cannot found')
      }
    } catch (err) {
      setLoading(false)
      setError(error)
    }
  }

  if (loading) {
    return (
      <div
        className="flex justify-center items-center"
        style={{ height: window.innerHeight }}
      >
        <LoadingOutlined
          style={{ fontSize: '75px', color: 'var(--blue-400)' }}
        />
      </div>
    )
  }

  if (error) {
    return (
      <div className="container text-lg">
        <h1>Something Error</h1>
        <p>{error.message}</p>
      </div>
    )
  }

  if (!data) {
    return null
  }

  return (
    <PrintEmailContent
      html={data}
      title={getTabName(type)}
      autoHeight
      capturePrintShortcut
    />
  )
}

export default observer(Template)
